import { MapPin, Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { AddressAutocomplete } from "../AddressAutocomplete";
import { useMasters } from "./MastersContext";

export function LocationsSection() {
  const { locations, addLocation, delLocation } = useMasters();
  const [val, setVal] = useState("");
  const [q, setQ] = useState("");
  const rows = locations.filter((l) => !q || l.address.toLowerCase().includes(q.toLowerCase()));

  async function add(e) {
    e.preventDefault();
    if (!val.trim()) return;
    await addLocation(val.trim());
    setVal("");
  }

  return (
    <section className="lg:col-span-2">
      <div className="flex items-center gap-2 mb-3"><MapPin className="w-4 h-4 text-[#C84B31]" /><div className="section-title mb-0">Locations</div><span className="text-[11px] text-[#68665E]">(auto-saved from everywhere — used for address autocomplete)</span></div>
      <form onSubmit={add} className="card-surface p-4 mb-4 flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[240px]">
          <AddressAutocomplete className="input-field w-full" placeholder="Add an address / location" value={val} onChange={setVal} onSelect={setVal} testId="location-input" />
        </div>
        <button type="submit" className="btn-primary" data-testid="add-location-button"><Plus className="w-4 h-4" /> Add Location</button>
      </form>
      <div className="table-wrap">
        <input className="input-field w-64 mb-3" placeholder="Search locations..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="location-search" />
        <table className="w-full">
          <thead><tr><th className="table-th">Address</th><th className="table-th text-right">Uses</th><th className="table-th text-right"></th></tr></thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td className="table-td text-[#68665E] text-center" colSpan={3}>{q ? "No matching locations." : "No saved locations yet — they build up automatically as you use the app."}</td></tr>
            ) : rows.map((l) => (
              <tr key={l.id} className="table-row" data-testid={`location-row-${l.id}`}>
                <td className="table-td">{l.address}</td>
                <td className="table-td text-right text-[#68665E]">{l.uses || 1}</td>
                <td className="table-td text-right"><button className="btn-ghost text-[#8A2526]" onClick={() => delLocation(l.id)} data-testid={`location-delete-${l.id}`}><Trash2 className="w-4 h-4" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
